import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeftIcon } from 'lucide-react';
const TermsOfService = () => {
  return <div className="bg-[#0F1115] min-h-screen relative" data-id="element-1730">
      {/* Global Grain Texture */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none z-50 bg-grain mix-blend-overlay" data-id="element-1731"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 relative z-10" data-id="element-1732">
        <div className="max-w-3xl mx-auto" data-id="element-1733">
          <Link to="/" className="inline-flex items-center text-gray-400 hover:text-white transition-colors mb-8" data-id="element-1734">
            <ChevronLeftIcon className="w-5 h-5 mr-1" data-id="element-1735" />
            Back to Home
          </Link>

          <h1 className="text-4xl font-bold text-white mb-4" data-id="element-1736">
            Terms of Service
          </h1>
          <div className="text-sm text-gray-500 mb-8" data-id="element-1737">
            Last updated: June 1, 2023
          </div>

          <div className="prose prose-lg prose-invert max-w-none" data-id="element-1738">
            <div className="text-gray-300 space-y-6" data-id="element-1739">
              <p data-id="element-1740">
                Please read these Terms of Service ("Terms") carefully before
                using the CertifiedDevs website and services.
              </p>

              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1741">
                1. Acceptance of Terms
              </h2>
              <p data-id="element-1742">
                By accessing or using our Services, you agree to be bound by
                these Terms. If you do not agree to these Terms, you may not
                access or use the Services.
              </p>

              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1743">
                2. Description of Services
              </h2>
              <p data-id="element-1744">
                CertifiedDevs provides a platform connecting developers,
                freelancers, and teams with potential employers and clients. Our
                Services include developer profiles, job listings, team pages,
                blog content, and other related features.
              </p>

              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1745">
                3. User Accounts
              </h2>
              <p data-id="element-1746">
                To access certain features of our Services, you must register
                for an account. You agree to provide accurate, current, and
                complete information during the registration process and to
                update such information to keep it accurate, current, and
                complete.
              </p>
              <p data-id="element-1747">
                You are responsible for safeguarding your account and password.
                You agree not to disclose your password to any third party and
                to take sole responsibility for any activities or actions under
                your account, whether or not you have authorized such activities
                or actions.
              </p>

              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1748">
                4. User Content
              </h2>
              <p data-id="element-1749">
                Our Services may allow you to post, link, store, share and
                otherwise make available certain information, text, graphics,
                videos, or other material ("Content"). You are responsible for
                the Content that you post on or through the Services, including
                its legality, reliability, and appropriateness.
              </p>
              <p data-id="element-1750">
                By posting Content on or through the Services, you represent and
                warrant that:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1751">
                <li data-id="element-1752">
                  The Content is yours (you own it) or you have the right to use
                  it and grant us the rights and license as provided in these
                  Terms
                </li>
                <li data-id="element-1753">
                  The posting of your Content on or through the Services does
                  not violate the privacy rights, publicity rights, copyrights,
                  contract rights or any other rights of any person
                </li>
              </ul>

              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1754">
                5. Fees and Payment
              </h2>
              <p data-id="element-1755">
                Certain aspects of the Services may be provided for a fee. You
                agree to pay all fees in accordance with the pricing and payment
                terms presented to you for such Services.
              </p>
              <p data-id="element-1756">
                You will provide us with valid, up-to-date, and complete credit
                card or other payment information. You authorize us to charge
                such payment information for all Services listed in an order for
                the initial subscription term and any renewal subscription term.
              </p>

              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1757">
                6. Termination
              </h2>
              <p data-id="element-1758">
                We may terminate or suspend your account and bar access to the
                Services immediately, without prior notice or liability, under
                our sole discretion, for any reason whatsoever and without
                limitation, including but not limited to a breach of the Terms.
              </p>
              <p data-id="element-1759">
                If you wish to terminate your account, you may simply
                discontinue using the Services, or notify us that you wish to
                delete your account.
              </p>

              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1760">
                7. Limitation of Liability
              </h2>
              <p data-id="element-1761">
                In no event shall CertifiedDevs, nor its directors, employees,
                partners, agents, suppliers, or affiliates, be liable for any
                indirect, incidental, special, consequential or punitive
                damages, including without limitation, loss of profits, data,
                use, goodwill, or other intangible losses, resulting from:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1762">
                <li data-id="element-1763">
                  Your access to or use of or inability to access or use the
                  Services
                </li>
                <li data-id="element-1764">
                  Any conduct or content of any third party on the Services
                </li>
                <li data-id="element-1765">Any content obtained from the Services</li>
                <li data-id="element-1766">
                  Unauthorized access, use or alteration of your transmissions
                  or content
                </li>
              </ul>

              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1767">
                8. Governing Law
              </h2>
              <p data-id="element-1768">
                These Terms shall be governed and construed in accordance with
                the laws of the Netherlands, without regard to its conflict of
                law provisions.
              </p>

              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1769">
                9. Changes to Terms
              </h2>
              <p data-id="element-1770">
                We reserve the right, at our sole discretion, to modify or
                replace these Terms at any time. If a revision is material we
                will provide at least 30 days' notice prior to any new terms
                taking effect. What constitutes a material change will be
                determined at our sole discretion.
              </p>

              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1771">
                10. Contact Us
              </h2>
              <p data-id="element-1772">
                If you have any questions about these Terms, please contact us
                at:
              </p>
              <p data-id="element-1773">
                Email: legal@certifieddevs.com
                <br data-id="element-1774" />
                Address: Keizersgracht 241, 1016 EA Amsterdam, Netherlands
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default TermsOfService;